declare global {
  interface window {
    process: any
  }
}

const getEnvVar = variable => {
  let maVar = process.env[variable]

  if (typeof window !== 'undefined') {
    // declared in _document.tsx
    maVar = window.process?.env?.[variable]
  }

  return maVar
}

export default getEnvVar
